<template>
  <v-dialog
    persistent
    v-model="showWindow"
    scrollable
    max-width="1200"
    max-height="90%"
    min-width="90%"
  >
    <v-card height="100%" :loading="!fetched">
      <v-card-actions>
        <h3 class="pa-3 pt-1 pb-1">{{ $t("goods.reserved_goods") }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="showWindow = false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-text class="pt-5 pb-0 mb-0 px-3">
        <v-data-table
          v-if="items && items.length > 0"
          :items="items"
          :expanded="expanded"
          :headers="[
            { text: '', value: 'data-table-expand' },
            { text: $t('common.part'), value: 'brand', class: 'text-no-wrap' },
            { text: $t('common.title'), value: 'name', class: 'text-no-wrap' },
            {
              text: $t('common.amount'),
              value: 'amount',
              class: 'text-no-wrap',
            },
            { text: $t('common.price'), value: 'price', class: 'text-no-wrap' },
          ]"
          :footer-props="{
            'items-per-page-text': $t('tables.items_per_page'),
            'items-per-page-options': [
              10, 50, 100,
              //-1
            ],
          }"
        >
          <template v-slot:footer.page-text="props">
            {{
              $t("tables.x_of_y", [
                `${props.pageStart}-${props.pageStop}`,
                props.itemsLength,
              ])
            }}
          </template>
          <template v-slot:item.data-table-expand="props">
            <v-btn depressed fab x-small @click="toggleExpanded(props.item)">
              <v-icon v-if="expanded.includes(props.item)"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.price="props">
            {{formatCurrency(props.item.price)}}
          </template>
          <template v-slot:item.brand="props">
            <v-icon
              :title="$t('goods.no_reserved_goods')"
              x-small
              color="red"
              v-if="
                goods_reserves &&
                !goods_reserves.filter(
                  (reserve) =>
                    parseInt(reserve.possessor_id) === parseInt(props.item.id)
                ).length
              "
              >fa-exclamation-triangle</v-icon
            >
            {{ props.item.brand }}
            {{ props.item.part_number }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="px-0 pl-5 pr-5 pb-5">
              <div
                v-if="
                  goods_reserves &&
                  goods_reserves.filter(
                    (reserve) =>
                      parseInt(reserve.possessor_id) === parseInt(item.id)
                  ).length
                "
              >
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          {{ $t("common.storage") }}
                        </th>
                        <th class="text-left">
                          {{ $t("common.amount") }}
                        </th>
                        <th class="text-left">
                          {{ $t("goods.type_incoming") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="reserve in goods_reserves.filter(
                          (reserve) =>
                            parseInt(reserve.possessor_id) === parseInt(item.id)
                        )"
                        :key="reserve.id"
                      >
                        <td>
                          {{
                            reserve.goods_movement.storage &&
                            reserve.goods_movement.storage.name
                          }}
                          {{
                            reserve.goods_movement.rack &&
                            " / " + reserve.goods_movement.rack.name
                          }}
                          {{
                            reserve.goods_movement.shelf &&
                            " / " + reserve.goods_movement.shelf.name
                          }}
                        </td>
                        <td>

                          {{reserve.amount}}

                        </td>
                        <td>
                          <span
                            v-if="
                              reserve.goods_movement.goods_movement_basis &&
                              reserve.goods_movement.goods_movement_basis
                                .goods_movement_document_type
                            "
                          >
                            {{
                              $t(
                                "movementDocumentTypes.full." +
                                  reserve.goods_movement.goods_movement_basis
                                    .goods_movement_document_type.name
                              )
                            }}
                            №
                            {{
                              reserve.goods_movement.goods_movement_basis
                                .human_number
                            }}
                            {{
                              reserve.goods_movement.goods_movement_basis.date
                            }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-btn
                  color="warning"
                  elevation="0"
                  @click="removeGoodsReserve(item)"
                >
                  {{ $t("goods.remove_the_reserve") }}
                </v-btn>
              </div>
              <div v-else class="py-2">
                <div class="pb-3">
                  <v-icon x-small color="red">fa-exclamation-triangle</v-icon>
                  {{ $t("goods.no_reserved_goods") }}
                </div>
                <v-btn
                  color="success"
                  elevation="0"
                  @click="showGoodsReservationWindow(item)"
                >
                  {{ $t("goods.reserve_goods") }}
                </v-btn>
              </div>
            </td>
          </template>
          <template v-slot:no-data>
            {{ $t("common.no_data_available") }}
          </template>
          <template v-slot:no-results>
            {{ $t("common.no_data_available") }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <goods-reservation-window
      :show="goodsReservationWindow.isVisible"
      :part_number="goodsReservationWindow.part_number"
      :brand="goodsReservationWindow.brand"
      :amount="goodsReservationWindow.amount"
      @hide="goodsReservationWindow.isVisible = false"
      @selectGoodsForReserve="
        (selected) => {
          reserveGoods(selected);
          goodsReservationWindow.isVisible = false;
        }
      "
    />
  </v-dialog>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import GoodsReservationWindow from "@/components/storage/GoodsReservationWindow";
import CommonMixin from "@/mixins/common";

export default {
  name: "ReservedGoodsWindow",
  components: { GoodsReservationWindow },
  props: {
    show: false,
    items: null,
  },
  mixins: [CommonMixin],
  data() {
    return {
      expanded: [],
      goodsReservationWindow: {
        isVisible: false,
      },
    };
  },
  computed: {
    ...mapFields("goods_reserves", ["goods_reserves", "fetched"]),
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("hide");
        this.expanded = [];
      },
    },
  },
  watch: {
    show(to) {
      if (to) {
        this.fetchGoodsReserves();
      }
    },
  },
  methods: {
    fetchGoodsReserves() {
      this.$store.dispatch("goods_reserves/fetchGoodsReserves", this.items);
    },
    removeGoodsReserve(item) {
      this.$store
        .dispatch("goods_reserves/removeGoodsReserve", {
          id: item.id,
          type: item.type,
        })
        .then(() => {
          this.fetchGoodsReserves();
        });
    },
    showGoodsReservationWindow(item) {
      this.goodsReservationWindow.isVisible = true;
      this.goodsReservationWindow.part_number = item.part_number;
      this.goodsReservationWindow.brand = item.brand;
      this.goodsReservationWindow.amount = item.amount;
      this.goodsReservationWindow.item = {
        type: item.type,
        id: item.id,
      };
    },
    reserveGoods(data) {
      this.$store
        .dispatch("goods_reserves/reserveGoods", {
          ...data,
          ...this.goodsReservationWindow.item,
        })
        .then(() => {
          this.fetchGoodsReserves();
        });
    },
    toggleExpanded(item) {
      if (
        this.expanded.filter((i) => parseInt(i.id) === parseInt(item.id)).length
      ) {
        this.expanded = this.expanded.filter((i) => i.id !== item.id);
      } else {
        this.expanded.push(item);
      }
    },
  },
};
</script>

<style scoped></style>
